// Where a dropdown opened inside the 3D stage must render.
//
// Owner, 2026-09-29: "in 3d view full screen, when i select something, and the
// selected element panel opens up, the drop downs on that panel stop showing up
// until I resize the 3d view".
//
// WHY: antd renders every popup - Select, Dropdown, Tooltip, Popover - into
// document.body through a portal. Full screen is not a CSS state: the browser
// promotes ONE element into the top layer and renders that subtree ALONE, so a
// popup parked on document.body is outside the rendered tree and simply is not
// drawn. The control still opens, still has focus, still responds to the
// keyboard - it is invisible, which is why it looked like a rendering glitch
// that a resize "fixed" (leaving full screen puts body back on screen).
//
// So a popup inside the stage has to live inside the stage. This returns the
// nearest [data-stage-root] ancestor - the element that ModelStage hands to
// requestFullscreen - and falls back to document.body for every popup that is
// NOT inside the stage, which is the ordinary case and must keep behaving
// exactly as before.
export function popupInStage(trigger) {
  if (!trigger || typeof trigger.closest !== 'function') return document.body;
  // `closest` includes the element itself, which is right: a trigger that IS
  // the stage root (nothing does this today) still anchors inside it.
  const root = trigger.closest('[data-stage-root]');
  return root || document.body;
}

export default popupInStage;

// Where a MODAL or a TOAST must render while the stage is full screen.
//
// Owner, 2026-09-30: "trying to update all selected elements in construction
// tracking 3d view full screen mode, drop down showed but spinners on the
// status update are still going and when i exited full screen i found the
// warning popup". The confirm was waiting for an answer the whole time, behind
// the top layer, so the write never started and the spinner never stopped.
//
// popupInStage cannot serve these two. It walks up from the element that opened
// the popup, and neither of these HAS one: Modal.confirm is called imperatively
// from a promise, and a toast is raised from an api catch with no DOM anywhere
// near it. So this asks the browser the same question from the other end -
// what is in the top layer? - because whatever is there is the only subtree
// being drawn, and everything on document.body is invisible.
//
// It returns document.body when nothing is full screen, which is every ordinary
// page and must keep behaving exactly as it does today.
export function stageContainer() {
  // Not "the stage root" but "whatever is full screen". If some other element
  // is in the top layer, a modal parked on body is just as invisible there, and
  // putting it in the visible subtree is still the right answer.
  return document.fullscreenElement || document.webkitFullscreenElement || document.body;
}
